<template>
  <div class="col-10 mx-auto">
    <b-button
      block
      variant="primary"
      @click="goToNuovoQuestionario"
      class="my-2"
      disabled="true"
    >Crea nuovo questionario-funzione ancora in sviluppo-</b-button>
    <b-button
      block
      variant="primary"
      @click="goToNuovoAbbonamento"
      class="my-2"
    >Crea nuovo abbonamento</b-button>
    <b-button
      block
      variant="primary"
      @click="$router.push({
        name: 'NuovaCategoria'
      })"
      class="my-2"
    >Crea nuova categoria professionista</b-button>
    <b-button
      block
      variant="primary"
      @click="$router.push({
        name: 'ListaAbbonamenti'
      })"
      class="my-2"
    >Lista abbonamenti</b-button>

    <b-button block variant="primary" @click="goToListaUtenti" class="my-2">Lista Utenti</b-button>
    <!-- <b-button block variant="primary" @click="goToImpostazioni" class="my-2">Orari di Ricevimento</b-button> -->
  </div>
</template>
<script>
export default {
  name: "funzioni-admin",
  data() {
    return {
      form: {
        slug: null,
        nome: null,
        descrizione: null
      }
    };
  },
  methods: {
    goToNuovoQuestionario() {
      this.$router.push({
        name: "NuovoQuestionario"
      });
    },
    goToNuovoAbbonamento() {
      this.$router.push({
        name: "NuovoAbbonamento"
      });
    },
    goToListaUtenti() {
      this.$router.push({
        name: "ListaUtenti"
      });
    }
    // goToNuovoAbbonamento() {
    //   this.$router.push({
    //     name: "NuovoAbbonamento",
    //   });
    // },
  }
};
</script>
